import { Col, List, Row } from "antd";
import React, { memo, useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";

import { DeleteModal, TextComponent } from "../../../../components";
import styles from "./myTemplayes.module.css";

import { PiDotsThreeOutlineFill } from "react-icons/pi";
import { RiDeleteBinLine } from "react-icons/ri";
import img1 from "../../../../assets/staticImages/template1.png";
import img2 from "../../../../assets/staticImages/template2.png";
import img3 from "../../../../assets/staticImages/template3.png";
import img4 from "../../../../assets/staticImages/template4.png";
import img5 from "../../../../assets/staticImages/template5.png";
import img6 from "../../../../assets/staticImages/template6.png";
import img7 from "../../../../assets/staticImages/template7.png";
import img8 from "../../../../assets/staticImages/template8.png";

import downloadicon from "../../../../assets/downloadIcon.png";
import { EventPlanningMiddleware } from "../../../../Store/Middlewares/EventPlanningMiddleware";
import { useDispatch, useSelector } from "react-redux";

const data = [
  {
    title: "Flower Delight",
    img: img1,
  },
  {
    title: "Blue Heaven",
    img: img2,
  },
  {
    title: "Colorful Temp",
    img: img3,
  },
  {
    title: "Teal Magic",
    img: img4,
  },
  {
    title: "Elegant",
    img: img5,
  },
  {
    title: "Soft Template",
    img: img6,
  },
  {
    title: "Artistic",
    img: img7,
  },
  {
    title: "Floral",
    img: img8,
  },
  {
    title: "Flower Delight",
    img: img1,
  },
  {
    title: "Blue Heaven",
    img: img2,
  },
  {
    title: "Colorful Temp",
    img: img3,
  },
  {
    title: "Teal Magic",
    img: img4,
  },
  {
    title: "Elegant",
    img: img5,
  },
  {
    title: "Soft Template",
    img: img6,
  },
  {
    title: "Artistic",
    img: img7,
  },
  {
    title: "Floral",
    img: img8,
  },
];

const RenderItem = memo(({ item, deleteTemplate, downloadImage }) => {
  const navigate = useNavigate();
  const [dropdownOpen, setDropdownOpen] = useState();

  return (
    <List.Item
      style={{ userSelect: "none", cursor: "pointer" }}
      key={item?.id}
      onClick={() => {
        navigate("/templates/MyTemplateDetails", { state: { data: item } });
      }}
    >
      <Row className={styles.dotsCont}>
        <PiDotsThreeOutlineFill
          className={styles.dropdownBtn}
          onClick={(e) => {
            e.stopPropagation();
            setDropdownOpen(!dropdownOpen);
          }}
          size={35}
        />
      </Row>
      {dropdownOpen && (
        <Row className={styles.dropdown}>
          <Col>
            <Row
              className={styles.dropdownItem}
              onClick={(e) => {
                e.stopPropagation();
                downloadImage(item?.image, item?.name);
                setDropdownOpen(!dropdownOpen);
              }}
            >
              <img
                src={downloadicon}
                alt="downloadIcon"
                className={styles.downloadIcon}
              />
              <TextComponent textClass={styles.dropdownText}>
                Download
              </TextComponent>
            </Row>
          </Col>
          <Col>
            <Row
              className={styles.dropdownItem}
              onClick={(e) => {
                e.stopPropagation();
                deleteTemplate(item?.id);
                setDropdownOpen(!dropdownOpen);
              }}
            >
              <RiDeleteBinLine fontSize="1.1rem" />
              <TextComponent textClass={styles.dropdownText}>
                Delete
              </TextComponent>
            </Row>
          </Col>
        </Row>
      )}

      <img className={styles.image} src={item?.image} alt="example" />
      <TextComponent textClass={styles.textClass} text={item?.name} />
    </List.Item>
  );
});

function MyTemplates() {
  const MyTemplates = useSelector(
    (state) => state.EventPlanningReducer.MyTemplates
  );
  const [deleteModalOpen, setdeleteModalOpen] = useState(false);
  const [delId, setdelId] = useState(null);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(EventPlanningMiddleware.getMyTemplates());
  }, []);

  const deleteTemplate = (id) => {
    setdeleteModalOpen(true);
    setdelId(id);
  };

  const onDelete = () => {
    dispatch(EventPlanningMiddleware.deleteTemplate({ id: delId }));
  };
  // async function downloadImage(src, name) {
  //   const response = await fetch(src);

  //   const blobImage = await response.blob();

  //   const href = URL.createObjectURL(blobImage);

  //   const anchorElement = document.createElement("a");
  //   anchorElement.href = href;
  //   anchorElement.download = `${name}.png`;

  //   document.body.appendChild(anchorElement);
  //   anchorElement.click();

  //   document.body.removeChild(anchorElement);
  //   window.URL.revokeObjectURL(href);
  // }
  function downloadImage(src, name) {
    
    const href = `https://www.bestdayever.me/api/downloadFile?path=${src}`;
    const anchorElement = document.createElement("a");
    anchorElement.href = href;
    anchorElement.download = `${name}`;
    document.body.appendChild(anchorElement);
    anchorElement.click();
    document.body.removeChild(anchorElement);
  }
  return (
    <>
      <List
        className={styles.listClass}
        grid={{
          xs: 1,
          sm: 2,
          md: 2,
          lg: 3,
          xl: 4,
          xxl: 4,
        }}
        dataSource={MyTemplates}
        renderItem={(item) => (
          <RenderItem
            item={item}
            deleteTemplate={deleteTemplate}
            downloadImage={downloadImage}
          />
        )}
      />
      <DeleteModal
        deleteModalOpen={deleteModalOpen}
        setDeleteModalOpen={setdeleteModalOpen}
        delDesc={"Do you want to delete this"}
        title={"Template?"}
        onSubmit={onDelete}
      />
    </>
  );
}

export default MyTemplates;
